import React, { useState } from 'react'
import learningResourcesFilterContext from '../../contexts/learning-resources-filter'

const UsersFilterProvider = ({
    children,
    limit = 18,
}) => {
    const [ filters, setFilters ] = useState({ limit })
    return (
        <learningResourcesFilterContext.Provider value={{ filters, setFilters }}>
            {children}
        </learningResourcesFilterContext.Provider>
    )
}

export default UsersFilterProvider